import React from 'react';
import { number, string, node, oneOf } from 'prop-types';

import * as S from './styles';

const Tooltip = props => {
  const { children, className, title, placement, width } = props;

  return (
    <S.TooltipWrapper className={className}>
      {title && (
        <S.Tooltip placement={placement} width={width}>
          {title}
        </S.Tooltip>
      )}
      {children}
    </S.TooltipWrapper>
  );
};

Tooltip.propTypes = {
  children: node.isRequired,
  className: string,
  title: string,
  placement: oneOf(['top', 'bottom', 'left', 'right']),
  width: number,
};

Tooltip.defaultProps = {
  className: undefined,
  title: undefined,
  placement: 'bottom',
  width: undefined,
};

export default Tooltip;
